import { X25519PublicKey } from "sodium-plus";
import * as t from "io-ts";
import { pipe } from "fp-ts/lib/function";
import * as E from "fp-ts/lib/Either";

export type X25519PublicKeyFromBase64C = t.Type<X25519PublicKey, string, string>

export const X25519PublicKeyFromBase64: X25519PublicKeyFromBase64C = new t.Type<X25519PublicKey, string, string>(
  'PublicKeyFromBase64',
  (u): u is X25519PublicKey => u instanceof X25519PublicKey,
  (u, c) =>
    pipe(
      t.string.validate(u, c),
      E.chain(s => {
        try {
          return t.success(X25519PublicKey.from(s, "base64"));
        } catch (ex) {
          return t.failure(u, c, ex + '');
        }
      })
    ),
  a => a.toString("base64")
);
